import styled from "styled-components";
import { GrayColors } from "@smartsuite/types";

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledSelectedWrapper = styled.div<{
  isOpened: boolean;
  isInCaptionBlock: boolean | undefined;
  isDisabled: boolean | undefined;
}>`
  height: ${(props) => (props.isInCaptionBlock ? "22px" : "100%")};
  min-height: ${(props) => (props.isInCaptionBlock ? "22px" : "34px")};
  display: flex;
  background-color: ${GrayColors["G-0-5"]};
  align-items: center;
  order: ${(props) => (props.isInCaptionBlock ? 0 : -1)};
  border-right: 1px solid ${GrayColors["G-1-5"]};
  border-top: ${(props) =>
    props.isInCaptionBlock ? `1px solid ${GrayColors["G-1-5"]}` : "none"};
  border-left: ${(props) =>
    props.isInCaptionBlock ? `1px solid ${GrayColors["G-1-5"]}` : "none"};
  border-bottom: ${(props) =>
    props.isInCaptionBlock ? `1px solid ${GrayColors["G-1-5"]}` : "none"};
  padding: 0 5px 0 12px;
  border-radius: ${(props) => (props.isInCaptionBlock ? `5px` : "5px 0 0 5px")};
  margin-left: ${(props) => (props.isInCaptionBlock ? `10px` : "0")};
  justify-content: space-between;
  cursor: pointer;
  min-width: 140px;
  flex-shrink: 0;

  .dropdown-arrow {
    transition: transform 200ms ease-in;
    fill: ${GrayColors["G-4"]};
    margin-left: 6px;
  }

  ${(props) =>
    props.isOpened &&
    `
    .dropdown-arrow {
      transform: rotate(180deg);
    }
  `}
`;

export const StyledMainOptions = styled.div`
  padding-top: 5px;
  padding-bottom: 5px;
`;
